"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Notification Service
 * User notification api documentation
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissionBatchRoleReachoutDtoToJSON = exports.MissionBatchRoleReachoutDtoFromJSONTyped = exports.MissionBatchRoleReachoutDtoFromJSON = exports.MissionBatchRoleReachoutDtoTalentIndustryOperatorEnum = void 0;
const runtime_1 = require("../runtime");
const MissionRoleReachoutDto_1 = require("./MissionRoleReachoutDto");
/**
* @export
* @enum {string}
*/
var MissionBatchRoleReachoutDtoTalentIndustryOperatorEnum;
(function (MissionBatchRoleReachoutDtoTalentIndustryOperatorEnum) {
    MissionBatchRoleReachoutDtoTalentIndustryOperatorEnum["Or"] = "OR";
    MissionBatchRoleReachoutDtoTalentIndustryOperatorEnum["And"] = "AND";
})(MissionBatchRoleReachoutDtoTalentIndustryOperatorEnum = exports.MissionBatchRoleReachoutDtoTalentIndustryOperatorEnum || (exports.MissionBatchRoleReachoutDtoTalentIndustryOperatorEnum = {}));
function MissionBatchRoleReachoutDtoFromJSON(json) {
    return MissionBatchRoleReachoutDtoFromJSONTyped(json, false);
}
exports.MissionBatchRoleReachoutDtoFromJSON = MissionBatchRoleReachoutDtoFromJSON;
function MissionBatchRoleReachoutDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'talentIndustryOperator': !(0, runtime_1.exists)(json, 'talentIndustryOperator') ? undefined : json['talentIndustryOperator'],
        'talentIndustryIds': !(0, runtime_1.exists)(json, 'talentIndustryIds') ? undefined : json['talentIndustryIds'],
        'missionRoleIds': json['missionRoleIds'],
        'missionId': json['missionId'],
        'subject': json['subject'],
        'contentHTML': json['contentHTML'],
        'roles': (json['roles'].map(MissionRoleReachoutDto_1.MissionRoleReachoutDtoFromJSON)),
        'additionalReceipientUserId': json['additionalReceipientUserId'],
        'videoURL': !(0, runtime_1.exists)(json, 'videoURL') ? undefined : json['videoURL'],
    };
}
exports.MissionBatchRoleReachoutDtoFromJSONTyped = MissionBatchRoleReachoutDtoFromJSONTyped;
function MissionBatchRoleReachoutDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'talentIndustryOperator': value.talentIndustryOperator,
        'talentIndustryIds': value.talentIndustryIds,
        'missionRoleIds': value.missionRoleIds,
        'missionId': value.missionId,
        'subject': value.subject,
        'contentHTML': value.contentHTML,
        'roles': (value.roles.map(MissionRoleReachoutDto_1.MissionRoleReachoutDtoToJSON)),
        'additionalReceipientUserId': value.additionalReceipientUserId,
        'videoURL': value.videoURL,
    };
}
exports.MissionBatchRoleReachoutDtoToJSON = MissionBatchRoleReachoutDtoToJSON;
